import { ArrowRight, Link2, UserRoundCheck, Users } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';

const routes = [
  {
    title: 'Customer signs up on your site',
    badge: 'Simple signup · V1',
    icon: UserRoundCheck,
    steps: ['Agent introduces one person', 'Customer joins on your website', 'Proovam checks the subscription'],
    fit: 'Choose this when customers already sign up on your site.',
  },
  {
    title: 'Agent uses your customer form',
    badge: 'Guided form · V2',
    icon: Users,
    steps: ['You choose safe questions', 'Agent fills the approved form', 'Your system creates the account and confirms the subscription'],
    fit: 'Choose this when an Agent should help register a customer in person.',
  },
  {
    title: 'Share a tracked link',
    badge: 'Broadcast',
    icon: Link2,
    steps: ['Agent shares one campaign link', 'Customers sign up on your website', 'Proovam checks and attributes subscriptions'],
    fit: 'Choose this when an Agent reaches many people with a link.',
  },
];

const CampaignRouteExplainer = () => (
  <Dialog>
    <DialogTrigger asChild>
      <Button type="button" variant="outline">Compare ways to find customers</Button>
    </DialogTrigger>
    <DialogContent className="max-h-[90vh] w-[calc(100vw-24px)] max-w-5xl overflow-y-auto">
      <DialogHeader>
        <DialogTitle>How can Agents help you find subscribers?</DialogTitle>
        <DialogDescription>Choose the route that matches how your customers join. The goal is Subscription for all three routes.</DialogDescription>
      </DialogHeader>
      <div className="grid gap-4 md:grid-cols-3">
        {routes.map((route) => (
          <section key={route.badge} className="rounded-xl border border-gray-200 p-4">
            <route.icon className="h-7 w-7 text-brand-600" aria-hidden="true" />
            <p className="mt-3 text-xs font-semibold uppercase tracking-wide text-brand-600">{route.badge}</p>
            <h3 className="mt-1 text-base font-semibold text-gray-950">{route.title}</h3>
            <ol className="mt-4 space-y-3">
              {route.steps.map((step, index) => (
                <li key={step} className="flex items-start gap-2 text-sm text-gray-700">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-50 text-xs text-brand-600">{index + 1}</span>
                  <span>{step}</span>
                  {index < route.steps.length - 1 && <ArrowRight className="mt-1 h-3 w-3 shrink-0 text-gray-400" aria-hidden="true" />}
                </li>
              ))}
            </ol>
            <p className="mt-4 border-t border-gray-100 pt-3 text-xs leading-5 text-gray-500">{route.fit}</p>
          </section>
        ))}
      </div>
      <p className="rounded-lg bg-brand-50 p-3 text-sm leading-6 text-gray-700">
        In Guided form V2, passwords stay on your own site. An introduction or registration alone does not earn a reward: an eligible subscription must be verified first.
      </p>
    </DialogContent>
  </Dialog>
);

export default CampaignRouteExplainer;
